import { syncHistoryWithStore } from 'react-router-redux'
import { browserHistory } from 'react-router'
import configureStore from '../store/configureStore';


export const TOKEN_KEY = 'token';
export const USER_KEY = 'user';


export const CARGO_OPERATION_LOAD_KEY = 'LOAD';
export const CARGO_OPERATION_DISCHARGE_KEY = 'DISCHARGE';

export const store = configureStore();
export const history = syncHistoryWithStore(browserHistory, store);

export const ACCEPTEDMIMETYPE = "text/csv, image/gif, application/x-pdf, image/jpeg, image/png, application/msword, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, application/vnd.ms-powerpoint, image/svg+xml, application/vnd.ms-excel, application/x-excel, application/x-msexcel, application/excel, text/xls, application/vnd.ms-excel.addin.macroEnabled.12, application/vnd.ms-excel.sheet.binary.macroEnabled.12, application/vnd.ms-excel.sheet.macroEnabled.12, application/vnd.ms-excel.template.macroEnabled.12, application/vnd.ms-office";


// WEBPACK FOOTER //
// ./src/constants/common.js